import type { WorkspaceAnalyticCategory } from 'models/analytics';
import { createContext } from 'react';

export const WorkspaceAnalyticCategoryContext = createContext<WorkspaceAnalyticCategory>('Primary market');
